import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUserMonitoring } from '../../../../../model/docking';

@Component({
    selector: 'app-mop-operators-dialog',
    templateUrl: './mop-operators-dialog.component.html',
    styleUrls: ['./mop-operators-dialog.component.scss']
})
export class MopOperatorsDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<MopOperatorsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public mopOperatorsMessage: IMopOperatorsMessage
    ) {}
}

export interface IMopOperatorsMessage {
    aliveMonitors: number;
    requiredMonitors: number;
    usersMonitoring: IMopOperatorsMessageUser[];
}

export type IMopOperatorsMessageUser = Pick<IUserMonitoring, 'userName'> & { currentUser: boolean };
